import Icon from './Icon';

function Tomato({ hover, shadow, color1, color2, className, ...props }) {
  return (
    <Icon {...{ hover, shadow, color1, color2, className, ...props }}>
      <path
        fillRule="evenodd"
        fill={color1 || 'rgb(255, 0, 0)'}
        d="M577.500,60.945 C896.444,60.945 1155.000,314.141 1155.000,626.473 C1155.000,938.805 896.444,1192.000 577.500,1192.000 C258.556,1192.000 -0.000,938.805 -0.000,626.473 C-0.000,314.141 258.556,60.945 577.500,60.945 Z"
      />
      <path
        fillRule="evenodd"
        fill={color2 || 'rgb(102, 153, 51)'}
        d="M785.822,242.011 C814.914,293.235 831.793,336.491 831.793,336.491 C831.793,336.491 734.079,376.053 650.525,315.181 C587.510,400.052 428.482,436.886 428.482,436.886 C428.482,436.886 394.442,391.537 368.837,331.225 C297.378,389.743 244.568,353.734 244.568,353.734 C244.568,353.734 248.498,304.498 267.654,247.880 C169.807,257.986 87.753,238.177 87.753,238.177 C87.753,238.177 194.227,119.099 335.137,64.047 C421.704,30.226 488.167,33.499 526.564,41.052 C530.583,40.511 533.772,40.170 535.949,39.964 C542.331,24.873 552.395,9.391 561.223,3.762 C575.604,-5.406 626.528,10.956 626.528,10.956 C626.528,10.956 609.281,27.732 603.500,43.558 C651.065,36.306 720.914,36.396 802.589,69.734 C956.433,132.532 1068.281,279.042 1068.281,279.042 C1068.281,279.042 929.542,288.915 785.822,242.011 Z"
      />
    </Icon>
  );
}

export default Tomato;
